export function normalizeLineFeeds(value) {
  return value.replace(/\r\n/g, '\n').replace(/\n/g, '\r\n')
}

export function getFormData({ elements }) {
  const formData = {}
  Array.from(elements).forEach((ele) => {
    if (
      !ele.name ||
      ele.disabled ||
      ele.type === 'submit' ||
      ele.type === 'button' ||
      ele.type === 'file'
    )
      return

    if (ele.type === 'select-multiple' || ele.type === 'select-one') {
      Array.from(ele.options).forEach((opt) => {
        !opt.disabled && opt.selected && (formData[ele.name] = opt.value)
      })
    } else if (ele.type === 'checkbox' || ele.type === 'radio') {
      if (ele.classList.contains('checkbox-array')) {
        if (ele.checked) {
          if (formData[ele.name]) {
            formData[ele.name] = [...formData[ele.name], ele.value]
          } else {
            formData[ele.name] = [ele.value]
          }
        }
      } else {
        ele.checked && (formData[ele.name] = ele.value)
      }
    } else {
      formData[ele.name] =
        ele.type === 'textarea' ? normalizeLineFeeds(ele.value) : ele.value
    }
  })

  return formData
}

export function getFormFieldValueByKey(target, formData) {
  if (!Object.keys(formData).includes(target)) {
    return null
  }
  return formData[target]
}

export function getCartAttributeProperties(formData) {
  const properties = {}

  for (const [key, value] of formData.entries()) {
    if (key.includes('properties') && !!value) {
      const strippedKey = key.replace('properties[', '').replace(']', '')
      properties[strippedKey] = value
    }
  }

  return properties
}
